import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';
import { mwErrorHandling } from '../../helpers/errors';

// apicore
import { APICore } from '../../helpers/api/apiCore';

// actions
import { disabilitiesApiResponseSuccess, disabilitiesApiResponseError } from './actions';

// constants
import { DisabilityActionTypes } from './constants';

const api = new APICore();
const BASE_URL = '/disabilities/';

/**
 * Get all disabilities
 */
function* getAll(): SagaIterator {
    try {
        const response = yield call(api.get, { url: BASE_URL });
        yield put(disabilitiesApiResponseSuccess(DisabilityActionTypes.GET_DISABILITIES, response.data));
    } catch (error: any) {
        const mwHandled = yield call(mwErrorHandling, error);
        if (!mwHandled) yield put(disabilitiesApiResponseError(DisabilityActionTypes.GET_DISABILITIES, error));
    }
}

export function* watchGetAllDisabilities() {
    yield takeEvery(DisabilityActionTypes.GET_DISABILITIES, getAll);
}

function* disabilitiesSaga() {
    yield all([fork(watchGetAllDisabilities)]);
}

export default disabilitiesSaga;
